import { render, staticRenderFns } from "./RefreshButton.vue?vue&type=template&id=87a4bd5a&"
import script from "./RefreshButton.vue?vue&type=script&lang=js&"
export * from "./RefreshButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports